var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Col } from "react-bootstrap";
import { FormattedMessage, FormattedDate } from "@irati/utils/lang";
import { RewardAvatar, StyledRow, StyledHr, StyledButton, Title, SubTitle } from "./styled/StyledItem";
var ItemTemplate = /** @class */ (function (_super) {
    __extends(ItemTemplate, _super);
    function ItemTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemTemplate.prototype.render = function () {
        var _a = this.props, createdAt = _a.createdAt, title = _a.title, subTitle = _a.subTitle, imageSrc = _a.imageSrc, handleClick = _a.handleClick;
        return (React.createElement(StyledRow, null,
            React.createElement(StyledHr, null),
            React.createElement(Col, { xs: 3, sm: 2 },
                React.createElement(RewardAvatar, { src: imageSrc, extraLarge: true, withShadow: true })),
            React.createElement(Col, { xs: 4, sm: 5 },
                React.createElement(Title, null, title),
                subTitle && React.createElement(SubTitle, null, subTitle)),
            React.createElement(Col, { xsHidden: true, sm: 3 },
                React.createElement(FormattedDate, { year: "numeric", month: "short", day: "2-digit", value: createdAt })),
            React.createElement(Col, { xs: 5, sm: 2 },
                React.createElement(StyledButton, { onClick: handleClick, small: true },
                    React.createElement(FormattedMessage, { id: "recognition.account.rewards.viewButton" })))));
    };
    return ItemTemplate;
}(PureComponent));
export default ItemTemplate;
